import { useId } from 'react';
import { Box, Stack, Typography, useTheme } from '@mui/material';

import { TireStackSvg } from 'assets/svg/service-icons';
import Seo from 'components/Seo';
import TirePanel from 'components/TirePanel';
import { panelBorder } from 'theme/colors';

const Wheels: React.FC = () => {
  const theme = useTheme();
  const wheelsId = useId();

  return (
    <>
      <Seo
        title='Jyväskylän Huoltoykköset - Rengasmyynti ja rengashotelli'
        description='Rengasmyynti ja rengashotelli Jyväskylä'
        name='Jyväskylän Huoltoykköset: Rengasmyynti ja rengashotelli'
        type='website'
      />
      <Stack id={wheelsId} spacing={3} sx={{ '&': { color: 'typography.light' } }}>
        <Typography variant='h2'>RENGASMYYNTI JA RENGASHOTELLI</Typography>
        <Stack spacing={2}>
          <Typography variant='p3' sx={{ fontWeight: 'bold' }}>
            Kunnon renkaat ovat halpa henkivakuutus!
          </Typography>
          <Typography variant='p3'>
            Meiltä saat järkevän tarjouksen kunnon talvi- ja kesärenkaille. Tule käymään niin tarkistamme veloituksetta renkaasi! Me
            säilytämme rengashotellissamme autosi renkaita sesongin ylitse kuin omiamme. Rengashotellitarjouksemme pitää sisällään renkaiden
            pesun ja allevaihdon.
          </Typography>
        </Stack>
        <Box
          display='grid'
          gridTemplateColumns='repeat(2, 1fr)'
          gap={3}
          sx={{
            [theme.breakpoints.down('sm')]: {
              gridTemplateColumns: 'repeat(1, 1fr)',
            },
          }}
        >
          <Box
            gridColumn='span 1'
            sx={{
              border: panelBorder,
              borderRadius: '14px',
              overflow: 'hidden',
              bgcolor: 'rgba(255,255,255,0.035)',
            }}
          >
            <Stack spacing={0}>
              <TirePanel minHeight={220} />
              <Stack spacing={1} sx={{ p: 3 }}>
                <Typography variant='p2'>Rengasmyynti</Typography>
                <Typography variant='p3'>
                  Kunnon renkaat ovat halpa henkivakuutus! Meiltä saat järkevän tarjouksen kunnon talvi- ja kesärenkaille. Tule käymään niin
                  tarkistamme veloituksetta renkaasi!
                </Typography>
              </Stack>
            </Stack>
          </Box>
          <Box
            gridColumn='span 1'
            sx={{
              border: panelBorder,
              borderRadius: '14px',
              overflow: 'hidden',
              bgcolor: 'rgba(255,255,255,0.035)',
            }}
          >
            <Stack spacing={0}>
              <TirePanel minHeight={220} icon={TireStackSvg} glowPosition='70% 20%' />
              <Stack spacing={1} sx={{ p: 3 }}>
                <Typography variant='p2'>Rengashotelli</Typography>
                <Typography variant='p3'>
                  Me säilytämme renkaitasi sesongin ylitse kuin omiamme. Rengashotellitarjouksemme pitää sisällään renkaiden pesun ja
                  allevaihdon.
                </Typography>
              </Stack>
            </Stack>
          </Box>
        </Box>
      </Stack>
    </>
  );
};

export default Wheels;
